export default {
  iconUp: 'Move up',
  iconDown: 'Move Down',
  iconAdd: 'Add',
  iconEdit: 'Edit',
  iconDelete: 'Delete',
  iconConfig: 'Advanced settings',
  iconCopy: 'Copy',
  iconSave: 'Save',
  iconCancel: 'Cancel',
  iconImage: 'Upload image',
  btnSave: 'Save',
  btnClose: 'Close',
  btnCancel: 'Cancel',
  widthImage: 'Landscape',
  longImage: 'Portrait',
  tipOptionNull: 'Can\'t be empty!',
  tipImageNull: 'Upload the images!',
  tipDescNull: 'Question cannot be empty!',
  tipCeOptionNull: 'ZIP code and name cannot be empty!',
  tipSubQuestionNull: 'Sub-questions cannot be empty!',
  tipChooseTypeNull: 'Choice type cannot be empty!',
  tipAnQuItemIdNull: 'Option cannot be empty!',
  tipSortQuItemIdNull: 'Sort content cannot be empty!',
  tipAnValueNull: 'Add option values',
  tipGeLeNull: 'Interval cannot be empty!',
  tipMinValueNull: 'Minimum value cannot be empty!',
  tipMaxValueNull: 'Maximum value cannot be empty!',
  tipLogicTypeNull: 'Logic type cannot be empty!',
  tipToQuIdNull: 'Skip question cannot be empty',
  tipToQuValueNull: 'Assigned content cannot be empty!',
  tipToQuItemIdNull: 'Skip question cannot be empty',
  tipAnAndNull: 'Condition cannot be empty!',
  tipAnQuIdNull: 'Question cannot be empty!',
  tipAnSubQuIdNull: 'Sub-questions cannot be empty!',
  tipTitleNull: 'Question cannot be empty!',
  tipAnswerNull: 'Answer option cannot be empty!',
  tipSortNull: 'Sorting is not complete yet!',
  tipScoreNull: 'Please rate this question!',
  tipRangeNull: 'Cannot exceed the range!',
  tipMax: 'Remaining distributable',
  tipNotMax: 'Not yet assigned completely!',
  tipRateNull: 'Swipe right to see further sub-questions',
  tipPhoneError: 'Enter a correct 11-digit mobile phone number',
  tipEmailError: 'Please enter a correct email address',
  tipBirthdayError: 'Please enter a correct birthday date',
  tipIdCardError: 'Please enter a correct ID number',
  tipIatAnswerNull: 'Swipe the item in the middle left or right as quickly as possible according your answer',
  tipNotEdit: 'The status of the questionnaire is not active:\' please go to Publish page and publish it.',
  msgAnswered: 'You have completed the questionnaire. Return to the activity page?',
  msgUnAnswered: 'You haven\'t completed the questionnaire. Return to the activity page?',
  regionName: 'Region name',
  imageType: 'Image type',
  addDimension: 'Add a dimension',
  allowChoiceNull: 'None of the above is allowed',
  tipQuestionError: 'Enter the question text',
  logicOption: 'Answer option logic',
  option: 'Option',
  optionContent: 'Option content',
  countNumber: 'Total',
  setUnit: 'Set-up units',
  customUnit: 'Custom units',
  usedUnit: 'Select a standard unit:',
  inputNumber: 'Enter number',
  inputAddPosition: 'Add an input position',
  mediaPosition: 'Media file position:',
  mediaUp: 'Media files up',
  mediaDown: 'Media files down',
  insertPosition: 'Insert position',
  playSpotInfo: 'Click on the information',
  playSpot: 'Click',
  simulationPosition: 'Simulated position:\' preview only',
  nowAtPosition: 'Current position',
  gpsError: 'Locating failed. Turn on GPS and allow browser and Wechat access the location',
  brandImage: 'Brand Images',
  addOption: 'Add options',
  brandName: 'Brand Name',
  imageUp: 'Image up',
  imageDown: 'Image down',
  positionPut: 'Set the position',
  maxSelectFive: 'You can add up to 5 options!',
  leftRightChoiceAnswer: 'Swipe the item in the middle left or right as quickly as possible according your answer',
  mediaType: 'Media Type:',
  minAnswer: 'Minimum:',
  maxAnswer: 'Maximum:',
  zeroNoAnswer: 'If you set the value to 0:\' it will make the question non-mandatory',
  openQuestion: 'Open ended question',
  mediaAudio: 'Audio',
  image: 'Image',
  mediaVideo: 'Video',
  recordingOnly: 'Recording only',
  recordingToWord: 'Speech-to-text-only',
  soundAndToWord: 'Record and convert to text',
  shotOnly: 'Record only',
  uploadOnly: 'Upload only',
  shotAndUpload: 'Both recordable and uploadable',
  inputNumerical: 'Enter the number',
  choiceTime: 'Choose a time',
  choiceYearMonth: 'Select year/month',
  choiceYearMonthDay: 'Select year/month/day',
  choiceDateTime: 'Choose a date',
  maxValue: 'Maximum value',
  minValue: 'Minimum value',
  supportType: 'Types supported:',
  Integer: 'Integer',
  supportDecimal: 'Support two decimals',
  startTime: 'Start time',
  choiceStartTime: 'Select start time',
  endTime: 'End time',
  choiceEndTime: 'Select end time',
  startYearMonth: 'Start year/month',
  choiceStartYearMonth: 'Select start year/month',
  endYearMonth: 'End year/month',
  choiceEndYearMonth: 'Select end year/month',
  startYearMonthDay: 'Start year/month/day',
  choiceStartYearMonthDay: 'Select start year/month/day',
  endYearMonthDay: 'End year/month/day',
  choiceEndYearMonthDay: 'Select end year/month/day',
  choiceStartDateTime: 'Select a start date',
  choiceEndDateTime: 'Select an end date time',
  answerLogic: 'Answer Logic',
  minValueNotNull: 'The minimum value cannot be empty',
  minValueLtMaxValue: 'The minimum value cannot be higher than the maximum',
  mustInteger: 'Must be an integer',
  maxTwoDecimal: 'Up to two decimals',
  maxValueNotNull: 'The maximum value cannot be empty',
  maxValueLtMinValue: 'The maximum value cannot be lower than the minimum value limit',
  supportTypeNotNull: 'Supporting type cannot be empty',
  second: 'Second',
  minute: 'Minute',
  hour: 'Hour',
  element: 'RMB',
  dollar: 'USD',
  euro: 'EUR',
  frequency: 'Times',
  day: 'Days',
  percentage: 'Percentage',
  timeRange: 'Time range',
  custom: 'Custom',
  hourMinute: 'Hour/min',
  date: 'Date',
  yearMonth: 'Year/month',
  yearMonthDay: 'Year/Month/Day',
  dateTime: 'Date/Time',
  pageNumber: 'Page number',
  npsTit: 'NPS',
  likertScale: 'Likert scale',
  star: 'Star',
  bipolarScale: 'Bipolar scale',
  silder: 'Slider',
  exactScale: 'Exact scale',
  againOrder: 'Ranking',
  pleaseInput: 'Please enter',
  middleValue: 'Value between',
  subQuestion: 'Sub-questions',
  questionStem: 'Question text',
  ifText: 'If',
  useMultiple: 'Multiple choices are allowed:\' and the relationship between options is orult',
  choiceSelect: 'Select an option',
  choiceSerial: 'Select serial number',
  rankingAs: 'Sorted as',
  choiceValue: 'Select a value',
  inputValue: 'Enter a value',
  and: 'And',
  middle: 'Between',
  be: 'Then',
  selectSubQuestion: 'Select a sub-question',
  addLogicOption: 'Add logic',
  ok: 'Confirm',
  questionType: 'Question type',
  currentQuestion: 'Current group',
  choiceSubQuestion: 'Please select a sub-question',
  showThat: 'Show',
  group: 'Group',
  question: 'Question',
  groupPrefixLogic: 'Pre-group logic',
  questionPrefixLogic: 'Pre-question logic',
  answerVer: 'Answer verification',
  addAnswerVer: 'Add answer verification criteria',
  thatQuestion: 'Question',
  thatAnswer: 'Answer',
  thatQuestionAnswer: 'Answer to the question',
  notAdd: 'Not added',
  viewOrModify: 'View/modify',
  screeningPart: 'Screening part',
  endPageSet: 'End page settings',
  setCompletionPage: 'Set up completion page',
  tipSample: 'Tip:\' Displayed when the sample status is:\' Complete /Overqouta.',
  title: 'Title',
  pleaseInputTitle: 'Enter the title',
  describe: 'Description',
  pleaseInputDescribe: 'Enter a description',
  setNotCompletionPage: 'Set up incomplete page',
  tipScreen: 'Tip:\' Displayed when the sample status is:\' Screenout /Quota is full.',
  projectNameNotNull: 'Project name cannot be empty',
  projectTypeNotNull: 'Project type cannot be empty',
  typeNotNull: 'Category cannot be empty',
  brandNotNull: 'Brand cannot be empty',
  projectCycleNotNull: 'Project timing cannot be empty',
  multilingualNotNull: 'Languages cannot be empty',
  flgNotNull: 'Label cannot be empty',
  tipText: 'Tips',
  gotIt: 'Got it',
  saveSuccess: 'Saved successfully',
  mainTitle: 'Main title',
  subTitle: 'Subtitle',
  addReferer: 'Add a reference',
  quote: 'Quote',
  of: 'Of',
  answer: 'Answer',
  alreadySelect: 'Answers selected',
  notSelect: 'No answers selected',
  optionOrder: 'Options display order',
  orderShow: 'Sequential display',
  randomShow: 'Random display',
  whileShow: 'Loop display',
  randType: 'Sorting',
  randByChildQu: 'Sub-questions',
  randByOption: 'Options',
  randBoth: 'All',
  answerNumber: 'Number of answers',
  minSelect: 'Minimum selection',
  unlimited: 'Unlimited',
  maxSelect: 'Maximum selection',
  optionSet: 'Option settings',
  customOptionMutex: 'Custom options are mutually exclusive',
  setExclusions: 'Set exclusive items',
  setMutex: 'Set mutual exclusions',
  pleaseCheckOtherOption: 'Select the exclusive options',
  checkTwoMutex: 'Select the 2 mutual exclusion options',
  confirmDelete: 'Confirm delete?',
  addQuestion: 'Add a question',
  to: 'To',
  beShowGroup: 'Then display this group',
  currentGroup: 'Current group and',
  existsLogic: 'This question has a logic:\' cannot delete until logic is removed!',
  project: 'Project',
  questionnaire: 'Questionnaire',
  logic: 'Logic',
  preview: 'Appearance',
  release: 'Release',
  downLoad: 'Download',
  maintainProject: 'Please update project information first!',
  questionnaireDatabase: 'Questionnaire Library',
  callQuestion: 'Call questionnaire',
  coverQuestion: 'Use the contents of the current questionnaire? Confirm to continue.',
  currentQuestionAnd: 'Current question and',
  existsRelation: 'Connected with a logic:\' cannot be deleted!',
  clickOrDragFile: 'Click or drag the file here to upload',
  setAlias: 'Please set the attachment alias',
  alias: 'Alias',
  fileFormatNotCorrect: 'Incorrect file format',
  file: 'File',
  notImageFormat: 'Incorrect format',
  maxLimitExceeded: 'Maximum limit exceeded',
  maxSetExceeded: 'Maximum limit set is exceeded',
  maxUpload: 'Select up to 5 files once to upload.',
  areaCode: 'ZIP code',
  noneOfTheAbove: 'None of the above',
  noneText: 'No',
  maxAddDimension: 'Up to 5 attributes can be added!',
  answerNotNull: 'The answer cannot be empty:\' please circle the pattern in the image above',
  unitNotNull: 'Units cannot be empty',

  submit: 'Submit',
  laststep: 'Last step',
  nextstep: 'next step',
  submittedsuccessfully: 'Submitted successfully',
  cover: {
    title: 'Voice of Customer',
    desc: 'Your feedback is important',
    subTitle: "We'd love to hear your feedback.",
    subDesc: "Your thoughts matter to us. That's why we've put together a short survey for the end of your visit - it will take less than a minute to complete.",
    btn: 'Start'
  },
  previewFinished: 'Preview finished',
  point: 'point',
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js